import { UTILITY_USER_ROLE_ANONYMOUS } from 'common/utility/userRoles';

export default {
  roles: [UTILITY_USER_ROLE_ANONYMOUS],
  sessionCount: 1,
};
